import { httpRequest } from "../base/httpRequest";

const ACCOUNT_URL = `/api/account/accId`;
const ADMIN_URL = `/api/admin`;

//api for helpdesk mode users
const createDemoDB = () => httpRequest("post", `${ADMIN_URL}/demo`);
const deleteDemoDB = () => httpRequest("delete", `${ADMIN_URL}/demo`);
const read_accounts = () => httpRequest("get", `${ADMIN_URL}/accounts`);
const updateAccountHelpMode = (id, isEnabled) =>
  httpRequest("put", `${ADMIN_URL}/helpdesk?id=${id}&enable=${isEnabled}`);
const read_users = (id) =>
  httpRequest("get", `${ADMIN_URL}/account/${id}/users`);
const reactive_user = (id, userid) =>
  httpRequest("put", `${ADMIN_URL}/account/${id}/user/${userid}/reactive`);
const update_account_subscription = (id, data) =>
  httpRequest("put", `${ADMIN_URL}/account/${id}/subscription`, data);
const download_account_data = () =>
  httpRequest("GET", `${ADMIN_URL}/report`, null, {
    responseType: "blob",
  });
const set_demo_source_account = (id, is_demo_source_account) =>
  httpRequest(
    "patch",
    `${ADMIN_URL}/account/${id}/demo_source?set_source=${is_demo_source_account}`,
  );

//normal url
const read_account_user = (type, status, accountId) =>
  httpRequest(
    "get",
    accountId
      ? `/api/account/${accountId}/users?type=${type}&status=${status}`
      : `${ACCOUNT_URL}/users?type=${type}&status=${status}`,
  );
const read_account_detail = () => httpRequest("get", `${ACCOUNT_URL}`);
const read_account_statistics = () =>
  httpRequest("get", `${ACCOUNT_URL}/statistics`);
const read_account_config = () => httpRequest("get", `${ACCOUNT_URL}/config`);
const read_account_integration_logs = () =>
  httpRequest("get", `${ACCOUNT_URL}/integration-logs`);
const update_account_detail = (data) =>
  httpRequest("patch", `${ACCOUNT_URL}`, data);
const update_user_role = (data) =>
  httpRequest("put", `${ACCOUNT_URL}/update_account_user`, data);
const report_error = (data) =>
  httpRequest("post", `${ACCOUNT_URL}/report_error`, data);
const read_subscription = () =>
  httpRequest("get", `${ACCOUNT_URL}/subscription`);

const invite_one_user = (data) =>
  httpRequest("post", `${ACCOUNT_URL}/user/invite`, data);

const activate_user_account = (userId) =>
  httpRequest("post", `${ACCOUNT_URL}/user/${userId}/reactive`);

const delete_account_user = (userId) =>
  httpRequest("delete", `${ACCOUNT_URL}/user/${userId}`);

const resend_email_to_user = (userId) =>
  httpRequest("put", `${ACCOUNT_URL}/user/${userId}/resend/email`);

const read_xero_settings = () =>
  httpRequest("get", `${ACCOUNT_URL}/xero/settings`);
const check_xero_connection = () =>
  httpRequest("get", `${ACCOUNT_URL}/xero/connection`);
const update_xero_settings = (data) =>
  httpRequest("put", `${ACCOUNT_URL}/xero/settings`, data);
const read_xero_accounts = () =>
  httpRequest("get", `${ACCOUNT_URL}/xero/accounts`);
const read_xero_tracking_categories = () =>
  httpRequest("get", `${ACCOUNT_URL}/xero/tracking_categories`);
const disconnect_from_xero = () =>
  httpRequest("delete", `${ACCOUNT_URL}/xero/tenant/disconnect`);
const read_xero_invoices = (searchQuery, numOfItems) => {
  const queryParamsList = [];

  if (searchQuery) {
    queryParamsList.push(`searchTerm=${encodeURIComponent(searchQuery)}`);
  }

  if (typeof numOfItems === "number") {
    queryParamsList.push(`pageSize=${encodeURIComponent(numOfItems)}`);
  }

  let url = `${ACCOUNT_URL}/xero/invoices`;
  if (queryParamsList.length) {
    url += `?${queryParamsList.join("&")}`;
  }

  return httpRequest("get", url);
};

// Demo mode
const toggle_demo_mode = (enableDemoMode) => {
  let reqType = "put";
  if (!enableDemoMode) {
    reqType = "delete";
  }

  return httpRequest(reqType, `${ACCOUNT_URL}/demo`);
};

export default {
  read_accounts,
  read_users,
  updateAccountHelpMode,
  reactive_user,
  update_account_subscription,
  download_account_data,
  set_demo_source_account,

  resend_email_to_user,
  delete_account_user,
  read_account_user,
  read_account_detail,
  read_account_statistics,
  read_account_config,
  read_account_integration_logs,
  update_account_detail,
  update_user_role,
  report_error,
  invite_one_user,
  activate_user_account,
  read_subscription,
  read_xero_settings,
  update_xero_settings,
  read_xero_accounts,
  read_xero_tracking_categories,
  disconnect_from_xero,
  read_xero_invoices,
  check_xero_connection,
  createDemoDB,
  deleteDemoDB,
  toggle_demo_mode,
};
